export const GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_REQUEST = "GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_REQUEST";
export const GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_SUCCESS = "GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_SUCCESS";
export const GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_FAILURE = "GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_FAILURE";

export const GET_DATA_SYNDICATION_SUBSCRIPTION_REQUEST = "GET_DATA_SYNDICATION_SUBSCRIPTION_REQUEST";
export const GET_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS = "GET_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS";
export const GET_DATA_SYNDICATION_SUBSCRIPTION_FAILURE = "GET_DATA_SYNDICATION_SUBSCRIPTION_FAILURE";

export const CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_REQUEST = "CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_REQUEST";
export const CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS = "CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS";
export const CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_FAILURE = "CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_FAILURE";

export const GET_SUBSCRIPTION_SOURCE_DATA_SETS_REQUEST = "GET_SUBSCRIPTION_SOURCE_DATA_SETS_REQUEST";
export const GET_SUBSCRIPTION_SOURCE_DATA_SETS_SUCCESS = "GET_SUBSCRIPTION_SOURCE_DATA_SETS_SUCCESS";
export const GET_SUBSCRIPTION_SOURCE_DATA_SETS_FAILURE = "GET_SUBSCRIPTION_SOURCE_DATA_SETS_FAILURE";

export const DELETE_DATA_SYNDICATION_SUBSCRIPTION_REQUEST = "DELETE_DATA_SYNDICATION_SUBSCRIPTION_REQUEST";
export const DELETE_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS = "DELETE_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS";
export const DELETE_DATA_SYNDICATION_SUBSCRIPTION_FAILURE = "DELETE_DATA_SYNDICATION_SUBSCRIPTION_FAILURE";

export const getDataSyndicationSubscriptionListRequest = () => ({
    type: GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_REQUEST,
});

export const getDataSyndicationSubscriptionListSuccess = (result) => ({
    type: GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_SUCCESS,
    payload: {
        result,
    },
});

export const getDataSyndicationSubscriptionListFailure = (error) => ({
    type: GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_FAILURE,
    payload: {
        error,
    },
});

export const getDataSyndicationSubscriptionRequest = (subscriptionId) => ({
    type: GET_DATA_SYNDICATION_SUBSCRIPTION_REQUEST,
    params: {
        subscriptionId,
    },
});

export const getDataSyndicationSubscriptionSuccess = (subscription) => ({
    type: GET_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS,
    payload: {
        subscription,
    },
});

export const getDataSyndicationSubscriptionFailure = (error) => ({
    type: GET_DATA_SYNDICATION_SUBSCRIPTION_FAILURE,
    payload: {
        error,
    },
});

export const confirmDataSyndicationSubscriptionRequest = ({ subscriptionId, targetBusinessAreaId, targetSchemaId, sourceDataSetId, targetDataSetId, includeExistingRecords }) => ({
    type: CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_REQUEST,
    params: {
        subscriptionId,
        targetBusinessAreaId,
        targetSchemaId,
        sourceDataSetId,
        targetDataSetId,
        includeExistingRecords,
    },
});

export const confirmDataSyndicationSubscriptionSuccess = (subscriptionId, result) => ({
    type: CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS,
    payload: {
        subscriptionId,
        result,
    },
});

export const confirmDataSyndicationSubscriptionFailure = (subscriptionId, error) => ({
    type: CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_FAILURE,
    payload: {
        subscriptionId,
        error,
    },
});

export const getSubscriptionSourceDataSetsRequest = (subscriptionId) => ({
    type: GET_SUBSCRIPTION_SOURCE_DATA_SETS_REQUEST,
    params: {
        subscriptionId,
    },
});

export const getSubscriptionSourceDataSetsSuccess = (dataSets) => ({
    type: GET_SUBSCRIPTION_SOURCE_DATA_SETS_SUCCESS,
    payload: {
        dataSets,
    },
});

export const getSubscriptionSourceDataSetsFailure = (error) => ({
    type: GET_SUBSCRIPTION_SOURCE_DATA_SETS_FAILURE,
    payload: {
        error,
    },
});

export const deleteDataSyndicationSubscriptionRequest = (subscriptionId) => ({
    type: DELETE_DATA_SYNDICATION_SUBSCRIPTION_REQUEST,
    params: {
        subscriptionId,
    },
});

export const deleteDataSyndicationSubscriptionSuccess = (subscriptionId) => ({
    type: DELETE_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS,
    payload: {
        subscriptionId,
    },
});

export const deleteDataSyndicationSubscriptionFailure = (subscriptionId, error) => ({
    type: DELETE_DATA_SYNDICATION_SUBSCRIPTION_FAILURE,
    payload: {
        subscriptionId,
        error,
    },
});
